import { ActionAfterViewed } from '@cian/action-after-viewed-component';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { CardSectionNew } from 'shared/components/CardSectionNew';
import { OfferSummaryInfoLayout, OfferSummaryInfoList } from 'shared/components/OfferSummaryInfo';
import { FeaturesNewV2 } from 'shared/containers/FeaturesNew';
import { SubscribeButtonContainer } from 'shared/containers/SavedSearchButtonContainer';
import { selectFeatures } from 'shared/selectors';
import { EFeaturesGroupID } from 'shared/types/features';

import { useShowSubscribeBtn } from './hooks';
import { ExpertOpinionBannerContainer } from '../ExpertOpinionBannerContainer';
import { trackAboutFlatAndHomeShow } from './tracking/tracking';

export const OfferSummaryInfoNewV2: React.FC = () => {
  const features = useSelector(selectFeatures);

  const [firstFeature, secondFeature, ...othersFeatures] = features || [];

  const legalFeatures = React.useMemo(() => {
    const legalFeaturesIndex = othersFeatures?.findIndex(feature => feature.id === EFeaturesGroupID.Legal);

    return othersFeatures?.splice(legalFeaturesIndex, 1)[0];
  }, [othersFeatures]);

  const showSubscribeBtn = useShowSubscribeBtn(secondFeature);

  if (!firstFeature) {
    return null;
  }

  return (
    <ActionAfterViewed callback={trackAboutFlatAndHomeShow}>
      <CardSectionNew>
        <OfferSummaryInfoLayout>
          <OfferSummaryInfoList
            header={firstFeature.title}
            features={firstFeature.features}
            actionButton={showSubscribeBtn ? <SubscribeButtonContainer /> : null}
          />

          {secondFeature && (
            <OfferSummaryInfoList
              header={secondFeature.title}
              features={secondFeature.features}
              actionButton={showSubscribeBtn ? <SubscribeButtonContainer /> : null}
              rightGroup
            />
          )}
        </OfferSummaryInfoLayout>

        {Boolean(legalFeatures) && (
          <OfferSummaryInfoLayout>
            <OfferSummaryInfoList header={legalFeatures.title} features={legalFeatures.features} />
          </OfferSummaryInfoLayout>
        )}

        <FeaturesNewV2 />

        {!!othersFeatures?.length && (
          <OfferSummaryInfoLayout>
            {othersFeatures.map(({ title, features }, index) => (
              <OfferSummaryInfoList key={title + index} header={title} features={features} />
            ))}
          </OfferSummaryInfoLayout>
        )}

        <ExpertOpinionBannerContainer />
      </CardSectionNew>
    </ActionAfterViewed>
  );
};
